import { useEffect } from "react";
import { Link } from "wouter";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export default function WelcomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-7648982144/kXtRCIDpqL8cEKKSstND",
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex flex-col items-center justify-center px-4 py-20">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-sm border border-green-100 p-10 text-center">
        <div className="flex justify-center mb-6">
          <CheckCircle2 className="h-16 w-16 text-green-600" strokeWidth={1.5} />
        </div>

        <h1 className="text-2xl font-bold text-slate-800 mb-2">
          歡迎加入 Skoltend！
        </h1>
        <p className="text-muted-foreground text-base mb-8 leading-relaxed">
          您的免費會員帳號已成功建立。<br />
          現在可以瀏覽全港學校招標資訊，掌握每日商機。
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/tenders">
            <Button className="bg-green-700 hover:bg-green-800 text-white px-8 rounded-full gap-2 w-full sm:w-auto">
              立即瀏覽標案
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
          <Link href="/dashboard">
            <Button variant="outline" className="px-8 rounded-full w-full sm:w-auto">
              前往控制台
            </Button>
          </Link>
        </div>

        <p className="text-xs text-muted-foreground mt-8 leading-relaxed">
          免費會員可查看標案標題、地區及截止日期。<br />
          升級付費計劃即可解鎖學校名稱、聯絡資料及每日通知。
        </p>

        <div className="mt-4">
          <Link href="/pricing" className="text-xs text-green-700 hover:underline font-medium">
            查看付費計劃 →
          </Link>
        </div>
      </div>
    </div>
  );
}
